import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;
  /* overflow-y: scroll; */
  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.brown.secundary};
    .logo {
      width: 500px;
      margin-top: 0vh;
      margin-bottom: -8vh;
      @media ${theme.devices.tablet} {
        width: 200px;
        margin-left: 7vw;
      }
    }
    .title {
      font-weight: bolder;
      font-size: ${theme.fontSize.lg};
      margin-top: -3vh;
      color: ${theme.colors.brown.primary};
    }
    .company {
      background-color: ${theme.colors.brown.primary};
      padding: 10px;
      padding-inline: 3vw;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
      margin-top: 8vh;
      @media ${theme.devices.tablet} {
        padding-inline: 10vw;
        margin-top: 8.2vh;
      }
      .lbl {
        font-weight: bolder;
        font-size: ${theme.fontSize.md};
        color: white;
        @media ${theme.devices.tablet} {
          font-size: ${theme.fontSize.mm};
        }
      }
    }
  }
  .middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f7e7cc;
    padding-bottom: 2vh;
    .title {
      font-weight: bolder;
      font-size: ${theme.fontSize.lg};
      margin-top: 3vh;
      color: ${theme.colors.brown.primary};
      font-family: sans-serif;
    }
    .process-qtd {
      display: flex;
      flex-direction: row;
      margin-top: 2vh;
      align-items: center;
      column-gap: 1vw;
      margin-bottom: 3vh;
      font-family: ${theme.fonts.primary};
      .container {
        font-size: ${theme.fontSize.mm};
        color: white;
        padding: 5px;
        background-color: ${theme.colors.brown.primary};
        padding-inline: 2.5vw;
        border-radius: 5px;
      }
      .data {
        font-size: ${theme.fontSize.mm};
        color: ${theme.colors.brown.primary};
      }
      @media ${theme.devices.tablet} {
        column-gap: 4vw;
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    background: #faf4eb;
    height: 100%;
    width: 100%;
    .row {
      display: flex;
      flex-direction: row;
      height: 100%;
      width: 100%;
      overflow-wrap: anywhere;
      flex: 2;
      .form {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-inline: 4vw;
        .label {
          font-size: ${theme.fontSize.md};
          color: ${theme.colors.brown.primary};
          margin-top: 2vh;
          margin-bottom: 1vh;
        }
      }
      @media ${theme.devices.tablet} {
        flex-direction: column;
        width: 95%;
        margin-bottom: 5vh;
      }
    }
    .btns-contaienr {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      column-gap: 2vw;
    }
  }
`;

export const HomeInput = styled.input<{ width: string }>`
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  color: black;
  font-size: ${theme.fontSize.mm};
  width: ${(props) => props.width};
`;
export const TextAreaInput = styled.textarea`
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  color: black;
  font-size: ${theme.fontSize.mm};
  width: 100%;
  resize: none;
  font-family: sans-serif;
`;

export const SubmitBtn = styled.button`
  font-size: ${theme.fontSize.mm};
  color: white;
  padding: 5px;
  background-color: ${theme.colors.brown.primary};
  padding-inline: 2.5vw;
  border-radius: 5px;
  margin-top: 3vh;
  margin-bottom: 5vh;
  width: 25vw;
  align-self: center;
  &:disabled {
    background-color: ${theme.colors.brown.capivara};
    cursor: not-allowed;
    opacity: 0.7;
  }
  @media ${theme.devices.tablet} {
    margin-bottom: 0vh;
    margin-top: 2vh;
    padding: 10px;
    width: 100%;
    font-size: ${theme.fontSize.md};
  }
`;
export const InputLbl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .lbl {
    font-size: ${theme.fontSize.mm};
    margin-top: 1vh;
    align-self: center;

    color: ${theme.colors.brown.primary};
  }
`;
export const ScenarioContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .datagrid-container {
    display: flex;
    width: 75vw;
    height: 75vh;
    align-self: center;
    flex-direction: column;
    @media ${theme.devices.tablet} {
      width: 90vw;
      height: 80vh;
    }
  }
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 2vw;
  width: 100%;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    justify-self: center;
    display: flex;
    width: 93%;
  }
`;

export const AccountSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 35vw;
  min-width: 35vw;
  width: 100%;
  .label {
    color: white;
    width: 100%;
    font-size: ${theme.fontSize.mm};
    text-align-last: right;
    margin-right: 1vw;
    @media ${theme.devices.tablet} {
      text-align-last: auto;
      margin-left: 5vw;
      width: 70vw;
    }
  }
  @media ${theme.devices.tablet} {
    max-width: 95vw;
    min-width: 95vw;
    column-gap: 0px;
    margin-bottom: 2vh;
  }
`;

export const SelectsContainerMain = styled.div`
  display: flex;
  margin-top: 2vh;
  flex-direction: column;
  row-gap: 2vh;
`;

export const SelectsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  column-gap: 1vw;
  .btn-containers {
    display: flex;
    margin-top: auto;
    margin-bottom: 1px;
    column-gap: 10px;
    @media ${theme.devices.tablet} {
      margin-top: 2vh;
    }
  }
  .btn-select {
    width: 45px;
    @media ${theme.devices.tablet} {
      width: 100%;
    }
  }
  .select-item {
    display: flex;
    flex-direction: column;
    width: 100%;
    row-gap: 1vh;
    .label-select {
      color: black;
      white-space: nowrap;
    }
  }
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;
export const FormContainerGrid = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.palete.brownLight};
  margin-inline: 3vw;
  .form-title {
    font-size: ${theme.fontSize.md2};
    color: white;
    align-self: center;
  }
`;
export const CardItem = styled.div`
  width: 90%;
  padding: 15px;
  border-radius: 5px;
  background: linear-gradient(to top right, #a9884d 80%, #c8a05e 50%);
  box-sizing: border-box;
  opacity: 1;
  align-self: center;
  place-items: center;
  margin-bottom: 2vh;
`;
export const BtnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 1vw;
  /* margin-top: 2vh; */
  width: 15%;
  align-self: end;
  margin-right: 5%;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    margin-bottom: 2vh;
    row-gap: 1vh;
    width: 25%;
  }
`;

export const CriterioRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    font-family: sans-serif;
    font-size: ${theme.fontSize.md};
    color: ${theme.colors.palete.brownDark};
    margin-bottom: 1vh;
    margin-top: -2vh;
    text-align: center;
    @media ${theme.devices.tablet} {
      margin-top: 0vh;
    }
    strong {
      color: black;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .description {
    text-align: justify;
    background-color: ${theme.colors.palete.brownLight};
    padding: 10px;
    margin-top: 0vh;
    margin-bottom: 2vh;
    border-radius: 5px;
    color: white;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  width: 100%;
  height: 100%;
  row-gap: 1vh;
  margin-top: 4vh;
  margin-bottom: 4vh;
  @media ${theme.devices.tablet} {
    overflow-y: scroll;
    height: 75vh;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: -4vh;
  justify-content: center;
  @media ${theme.devices.tablet} {
    margin-top: -3vh;
  }
`;

export const TopCardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 3vh;
  margin-top: 5vh;
  @media ${theme.devices.tablet} {
    place-content: center;
  }
  .input-container {
    cursor: pointer;
    margin-left: 4vw;
    width: 350px;
    display: flex;
    flex-direction: column;
    column-gap: 1vw;
    position: relative; /* Necessário para posicionamento do ícone */
    @media ${theme.devices.tablet} {
      width: 85%;
    }
  }
`;

export const TitleInput = styled.input<{ isEmpty: boolean }>`
  background: transparent;
  color: white;
  border: ${(props) =>
    props.isEmpty ? "solid 1px white" : "none"}; /* Exibe borda quando vazio */
  border-radius: 10px;
  font-size: 19px;
  padding: 10px;
  width: 90%;
  font-family: sans-serif;
  font-weight: 600;
  transition: border 0.3s ease, background-color 0.3s ease;

  &::placeholder {
    color: white;
    padding: 5px;
  }

  &:focus {
    outline: none;
    border: solid 1px ${theme.colors.palete.gold}; /* Borda dourada ao focar */
  }

  &:hover {
    background-color: ${theme.colors.palete.gold};
  }

  &:not(:focus):not(:placeholder-shown) {
    /* Quando houver texto e o input não estiver em foco, parece com uma label */
    border: none;
    background: transparent;
  }
`;

export const IconContainer = styled.div<{
  isHovered: any;
  isFocused: any;
  isEmpty: any;
}>`
  position: absolute;
  right: 0px;
  top: 0%;
  transform: translateY(-50%);
  transition: opacity 0.3s ease;
  opacity: ${(props) =>
    props.isHovered || props.isFocused || props.isEmpty
      ? 1
      : 0}; /* Exibe ícone no hover ou quando vazio */

  &:hover {
    opacity: 1; /* Exibe o ícone ao passar o mouse */
  }
`;
export const ContainerCriterio = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  row-gap: 4vh;
  /* background-color: red; */
`;
